  <footer class="page-footer">
    <div class="footer-content">
      {{'general.copyright' | translate}}
    </div>
  </footer>
